import {
  Autocomplete,
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import TvIcon from "@mui/icons-material/Tv";
import React from "react";
import {
  getDataForCustomer,
  getLineChartDataForCustomer,
  sizes,
} from "../analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../analyzeSlice";

const selectWidth = sizes.w650;

export default function CustomerSelectionForm() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const {
    modificationsCustomers,
    modificationsSelCustomer,
    modificationsData,
  } = state;
  const { lstAnalyzeChartData } = modificationsData;

  function setCustomer_Value(customer) {
    dispatch(setState("modificationsSelCustomer", customer.name));
  }

  function setCustomer_inputValue(name) {
    dispatch(setState("modificationsSelCustomer", name));
  }

  function handleDisplay() {
    dispatch(setState("isLoading", true));
    dispatch(setState("modificationsSeries", []));
    const data = getLineChartDataForCustomer(
      lstAnalyzeChartData,
      modificationsCustomers
    );
    dispatch(setState("modificationsSeries", data));
    dispatch(setState("isLoading", false));
  }

  return (
    <Box sx={{ mt: 3 }}>
      <Grid container columns={12} columnGap={1}>
        <Grid item sm={12}>
          <Box
            sx={{
              mt: 1,
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
            }}
          >
            <Typography variant="subtitle1" sx={{ mr: 1 }}>
              Total Customers:{" "}
            </Typography>
            <Typography variant="subtitle1" sx={{ mr: 1, fontWeight: "bold" }}>
              {modificationsCustomers?.length}
            </Typography>
          </Box>
        </Grid>

        <Grid item sm={10.3}>
          <Autocomplete
            // value={modificationsSelCustomer}
            // onChange={(event, newValue) => {
            // 	setCustomer_Value(newValue);
            // }}
            inputValue={modificationsSelCustomer}
            onInputChange={(event, newInputValue) => {
              setCustomer_inputValue(newInputValue);
            }}
            options={modificationsCustomers}
            sx={{ width: "100%", mr: 2, mt: 2 }}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Customers" />
            )}
          />
        </Grid>

        <Grid sm={1.6}>
          <Button
            startIcon={<TvIcon />}
            sx={{
              bgcolor: "blue.main",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              mt: 2,
              ml: 2,
              "&:hover": {
                bgcolor: "skyBlue.main",
                color: "black.main",
              },
            }}
            onClick={handleDisplay}
          >
            Display Data
          </Button>
        </Grid>
      </Grid>

      <Divider sx={{ mt: 3, mb: 3 }} />
    </Box>
  );
}
